'use strict';

var $ = require('jquery');

function httpClient(config) {
    var defaults = {
        method: 'GET',
        contentType: 'application/x-www-form-urlencoded',
        xhrFields: {
            withCredentials: true
        }
    };

    var settings = $.extend({}, defaults, config);

    if (!config || !config.data || !config.data.csrf_token) {
        settings.data = $.extend({}, settings.data, {
            csrf_token: $('#adyen-token').val()
        });
    }
    return $.ajax(settings);
}

module.exports = {
    httpClient: httpClient
};
